import getDeviceByScreenSize from '../getDeviceByScreenSize';
import mapThumbnails from '../mapThumbnails';
var defaultPreviewThumbnails = {
  previewThumbnails: {
    enabled: false,
    src: ''
  }
};

var getVideoData = function getVideoData(mediaObjects) {
  var device = getDeviceByScreenSize();
  var sourceType = mediaObjects[device] ? mediaObjects[device] : mediaObjects.main;
  var sources = sourceType.filter(function (media) {
    return media.type === 'video';
  });
  var posters = sourceType.filter(function (media) {
    return media.type === 'image';
  });
  var audio = sourceType.filter(function (media) {
    return media.type === 'audio';
  })[0];
  var thumbnail = sourceType.filter(function (media) {
    return media.type === 'thumbnail';
  })[0];
  var thumbnailsConfig = thumbnail ? mapThumbnails(thumbnail) : defaultPreviewThumbnails;
  return {
    audio: audio,
    sources: sources,
    posters: posters,
    thumbnailsConfig: thumbnailsConfig
  };
};

export default getVideoData;